import {translate} from 'vue-gettext'

const {pgettext: $pgettext} = translate

export const photoServiceEventsFieldsER = {
    'pica_service_name': {
        key: 'pica_service_name',
        label: $pgettext('stats', 'Name'),
    },
    'turnover': {
        key: 'turnover',
        label: $pgettext('stats', 'Revenues'),
        _style: 'text-align:right'
    },
    'presale': {
        key: 'presale',
        label: $pgettext('stats', 'Pre-sale'),
        _style: 'text-align:right'
    },
    'amount': {
        key: 'amount',
        label: $pgettext('stats', 'Total'),
        _style: 'text-align:right'
    },
}

export const photoServiceEventsFields = {
    'pica_service_name': {
        key: 'pica_service_name',
        label: $pgettext('stats', 'Name'),
    },
    'start_at': {
        key: 'start_at',
        label: $pgettext('stats', 'Start at'),
    },
    'turnover': {
        key: 'turnover',
        label: $pgettext('stats', 'Revenues'),
        _style: 'width:200px'
    },
    'presale': {
        key: 'presale',
        label: $pgettext('stats', 'Pre-sale'),
        _style: 'text-align:right'
    },
    'amount': {
        key: 'amount',
        label: $pgettext('stats', 'Total'),
        _style: 'text-align:right'
    },
}

export const saasPaymentsListFields = {
    'order_id': {
        key: 'order_id',
        label: $pgettext('stats', 'Order ID'),
        _style: 'width:120px'
    },
    'order_type_label': {
        key: 'order_type_label',
        label: $pgettext('stats', 'Type'),
        _style: 'width:150px'
    },
    'pica_service_name': {
        key: 'pica_service_name',
        label: $pgettext('stats', 'Pica Service'),
    },
    'amount_eur': {
        key: 'amount_eur',
        label: $pgettext('stats', 'Amount'),
        _style: 'text-align:right;width:120px',
        filter: false
    },
    'created_at': {
        key: 'created_at',
        label: $pgettext('stats', 'Date'),
        _style: 'width:120px',
        filter: false
    },
}

export const reportOptions = {
    ALL: {
        value: 'all',
        label: $pgettext('stats', 'All'),
    },
    FREE: {
        value: 'free',
        label: $pgettext('stats', 'Free'),
    },
    PAID: {
        value: 'paid',
        label: $pgettext('stats', 'Paid'),
    },
}